import { useFont } from '@octane/spark'
import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    align-items: center;
    @media print {
        display: flex;
        align-items: last baseline;
    }
`

export const TitleSubmissionTimeLimit = styled.span`
    ${() => useFont('c16', { weight: '700' })};
    color: ${(props) => props.theme.colors.alert.warning};
`
